/**
 * API配置文件
 * 包含后端地址和API路径
 */

// 后端基础地址
export const BASE_URL = 'https://web.wuhantianran.top';

// API路径
export const API = {
  // 轮播图API
  BANNER: '/api/banner',
  
  // 漫画列表API
  COMIC: '/api/comic',
  
  // 用户API
  USER: '/api/user',
  
  // 分类API
  CATEGORY: '/api/category',
  
  // 关于我们API
  ABOUT: '/api/about/index',
  
  // 可以在这里添加更多API路径
  // TV_SERIES: '/api/tv_series',
  // RANKING: '/api/ranking',
};

// 完整的API URL
export const getApiUrl = (path) => `${BASE_URL}${path}`; 